<template>
  <tr>
    <th>
      제목
      <span v-if="required" class="required">*</span>
      <div class="count">
        (
        <span class="current">{{ boardTitle_local.length }}</span
        >/30)
      </div>
    </th>
    <td>
      <input type="text" class="inp_text" maxlength="30" style="width: 100%" v-model="boardTitle_local" ref="input" />
      <p class="caution">
        <span class="ico">*</span> 스피커 Push 알림으로 나갈 안내 메시지입니다. 실제 안내는 <br />"아리아, 소식톡톡 알려줘 라고
        말씀해보세요." 라는 메시지가 추가되어 전송됩니다.
      </p>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    boardTitle: String,
    required: Boolean,
  },
  data() {
    return {
      boardTitle_local: this.boardTitle,
    };
  },
  watch: {
    boardTitle_local(val) {
      this.$emit('update:boardTitle', val.trim());
    },
  },
  methods: {
    validate() {
      if (this.required && !this.boardTitle) {
        alert('제목을 입력해 주세요.');
        this.$refs.input.focus();
        return false;
      }
      return true;
    },
  },
};
</script>

<style></style>
